
import { Prop, Vue, Component } from 'vue-property-decorator';

@Component
export default class BaseCheckbox extends Vue {
    @Prop({ required: true }) readonly id!: string;
    @Prop({ required: true }) readonly label!: string;
    @Prop({ required: true }) readonly value!: any;
    @Prop({ required: true }) readonly checked!: boolean;

    handleChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        if (target) {
            this.$emit('change', target.checked);
        }
    }
}
